import { Types } from '@grandvisionhq/graphql';
import { getLocalizedValue, getLocalizedString } from '@grandvisionhq/utils';
import { isContactLensesOrderLineItem, isSolutionOrderLineItem } from './order-line-item-product-type-guards.js';

const toEyeSideLabelKey = (eyeSide)=>{
    switch(eyeSide){
        case Types.EyeSide.LEFT:
            return 'products.contactLenses.leftEye';
        case Types.EyeSide.RIGHT:
            return 'products.contactLenses.rightEye';
        case Types.EyeSide.BOTH:
            return undefined;
    }
};
const getProductSubtitle = (orderLineItem, intl)=>{
    const { locale , getLabel  } = intl;
    if (isContactLensesOrderLineItem(orderLineItem)) {
        const { eyeSide  } = orderLineItem;
        const { boxQuantity , replacementFrequency  } = orderLineItem.product;
        const eyeSideLabelKey = toEyeSideLabelKey(eyeSide);
        const eyeSideLabel = eyeSideLabelKey ? getLabel(eyeSideLabelKey).toLowerCase() : undefined;
        /**
     * Some of these values can end up in an empty string, in which case
     * we want to not add a space character for that value.
     */ const spaceJoinedSections = [
            boxQuantity,
            getLocalizedValue(replacementFrequency, locale),
            getLabel('products.unit.contactLenses'), 
        ].filter(Boolean).join(' ');
        const commaJoinedSections = [
            getLabel('products.perBox'),
            eyeSideLabel
        ].filter(Boolean).join(', ');
        return `${spaceJoinedSections} ${commaJoinedSections}`;
    }
    if (isSolutionOrderLineItem(orderLineItem)) {
        const { volume , volumeUnit  } = orderLineItem.product;
        return volume && volumeUnit ? `${volume}${volumeUnit}` : undefined;
    }
    const { brand , modelCode , name  } = orderLineItem.product;
    if (!modelCode || (brand === null || brand === void 0 ? void 0 : brand.includes(modelCode)) || getLocalizedString(name, locale).includes(modelCode)) {
        return '';
    }
    return modelCode;
};

export { getProductSubtitle };
//# sourceMappingURL=get-product-subtitle.js.map
